import React, { FC } from 'react';
import { useRole } from 'common/hooks/useRole';

export const AdministrationGuard: FC = ({ children }) => {
  const { isAdministrationRole } = useRole();
  if (isAdministrationRole) {
    return <>{children}</>;
  }

  return null;
};
